import React, {Component} from 'react';
import {db_tables, DBHelpers, isLogin, rd, route, routes, throws} from "../../vars/rd";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import DaoUser from "../../modules/dao/user";


class AuthLogout extends Component {
    timeoutId = null;
    constructor(props) {
        super(props);
        if(!isLogin()) route(routes.login);
    }

    async componentDidMount() {
        DBHelpers.openDB()
            .then(async db => {
                const users = await db.select(db_tables.users, () => true);
                if (users) {
                    await db.updateBulk(db_tables.users, {...users, mac: null}, doc => {
                        return doc.id === users.id
                    });
                }
            })
            .catch(err => throws(err.message));

        rd.user = new DaoUser();
        this.timeoutId = setTimeout(
            () => route(routes.login),
            100
        );
    }

    componentWillUnmount() {
        if(this.timeoutId) window.clearTimeout(this.timeoutId);
        this.timeoutId = null;
    }

    render() {
        return (
            <div>
            </div>
        );
    }
}

export default connect()(withRouter(AuthLogout));


// WEBPACK FOOTER //
// ./src/pages/auth/logout.jsx